/**
 * Created by luka on 02.03.2021.
 */

import React, { Component } from 'react'
import Chart from 'chart.js';
import i18n from 'i18next';

export default class LineGraph extends Component {

    componentDidMount() {
        this.buildChart();
    }

    componentDidUpdate() {
        this.buildChart();
    }

    buildChart = () => {
        const ctx = document.getElementById("myChart").getContext("2d");
        var gradient = ctx.createLinearGradient(0, 210, 210, 0);
        gradient.addColorStop(0, "rgb(218, 255, 255, 0.3)");
        gradient.addColorStop(1, "rgb(218, 255, 255, 0.8)");
        gradient.addColorStop(1, "rgb(218, 255, 255, 0.8)");

        const { data, dataTitle, labels, currency } = this.props;
        new Chart(ctx, {
            type: "line",
            data: {
                //Bring in data
                labels: labels,
                datasets: [
                    {
                        label: dataTitle,
                        fill: true,
                        borderColor: "#fff",
                        backgroundColor: gradient,
                        data: data,
                    }
                ]
            },
            options: {
                legend: {
                    display: false,
                },
                scales: {
                    xAxes: [{
                        gridLines: {
                            display:false,
                        },
                        ticks: {
                            fontColor: '#fff',
                        },
                    }],
                    yAxes: [{
                        gridLines: {
                            display:false
                        },
                        ticks: {
                            fontColor: '#fff',
                            callback: function(value, index, values) {
                                const lang = i18n.language.split("-")[0] ? i18n.language.split("-")[0] : "en";
                                const formatter = new Intl.NumberFormat(lang, {
                                    style: 'currency',
                                    currency: currency.toUpperCase(),
                                    minimumFractionDigits: 0,
                                });

                                return formatter.format(value);
                            }
                        },
                    }]
                }
            }
        });
    };

    render() {
        return (
            <div>
                <canvas id="myChart"/>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/wallet/LineGraph.js